import { Box, styled, ToggleButtonGroup } from '@mui/material';
import MuiToggleButton from '@mui/material/ToggleButton';

interface MainBoxProps {
  alignment?: string;
}

export const Header = styled(Box)(({ theme }) => ({
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.background.default}`,
  display: 'flex',
  height: '56px',
  justifyContent: 'space-between',
  padding: theme.spacing(2),
  width: '100%',
}));

export const ToggleButton = styled(MuiToggleButton)(({ theme }) => ({
  color: theme.palette.primary.light,
  width: '50%',
  border: 'none',
  textTransform: 'none',
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.dark,
  },
  borderRadius: '2px',
  '&:hover': { backgroundColor: 'transparent', color: '#9E9E9E' },
}));

export const ToggleButtonPanel = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiButtonBase-root.MuiToggleButton-root.Mui-selected': {
    borderRadius: '2px',
  },
  height: '40px',
  width: '100%',
  marginBottom: theme.spacing(2),
  borderRadius: '2px',
  border: `4px solid ${theme.palette.background.default}`,
  backgroundColor: theme.palette.background.default,
}));

export const MainBox = styled(Box, { shouldForwardProp: (prop) => prop !== 'alignment' })<MainBoxProps>(
  ({ theme, alignment }) => ({
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '2px 2px 6px 0px rgba(0, 0, 0, 0.10)',
    borderRadius: '5px',
    backgroundColor: theme.palette.background.paper,
    height: alignment !== 'Leave' ? '95svh' : 'fit-content',
    width: '500px',
    maxWidth: '500px',
    position: 'sticky',
    top: theme.spacing(1),
    [theme.breakpoints.down('md')]: {
      position: 'fixed',
      width: '100%',
      height: 'fit-content',
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: '5dvh',
      width: '92%',
      maxWidth: '100%',
      height: '90dvh',
    },
  }),
);
